import { Component, Host, h, Prop, Element } from '@stencil/core';
import { getSvg } from '../../assets/svg/svg';

import { CssClassMap } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-share-content',
  styleUrl: 'cms-share-content.scss',
  shadow: true,
})
export class CmsShareContent {
  private socialIcon: string;
  private shareButtonNode: HTMLElement;

  private shareData = {
    url: window.location.href,
  };

  /**
   * set the Element css class
   */
  @Prop() cssClass = '';
  /**
   * set the target url ref
   */
  @Prop() href: string;
  /**
   * set the Share Label like Teilen
   */
  @Prop() label: string;
  /**
   * set the Share Title like 'Share on pinterest'
   */
  @Prop() linkTitle: string;
  /**
   * set the share Type like facebook etc
   */
  @Prop() type: 'facebook' | 'pinterest' | 'content';

  @Element() hostElement: HTMLElement;

  private shareAnchorCssClass(): CssClassMap {
    return {
      ['social-share-anchor']: true,
      [this.cssClass]: true,
    };
  }

  private addShareEvent() {
    if (
      window.navigator &&
      window.navigator.canShare &&
      window.navigator.canShare(this.shareData) &&
      this.shareButtonNode != undefined &&
      window.navigator.share !== undefined
    ) {
      this.shareButtonNode.addEventListener('click', () => {
        window.navigator
          .share(this.shareData)
          .then(() => {
            return console.info('Thanks for sharing!');
          })
          .catch(console.error);
      });
    } else {
      this.shareButtonNode.style.display = 'none';
      console.log('Share API not supported');
    }
  }

  private renderSocialShareAnchor(): HTMLElement {
    return (
      <a
        title={this.linkTitle}
        rel='noopener'
        class={this.shareAnchorCssClass()}
        target='_blank'
        href={this.href}
        innerHTML={this.socialIcon}
      ></a>
    );
  }

  private renderShareButton(): HTMLElement {
    return (
      <button aria-label='share content' type='button' class={'share-button'}>
        <span innerHTML={this.socialIcon} class={'svg-wrapper'}></span>
        <span class={'share-text'}>{this.label}</span>
      </button>
    );
  }

  componentWillLoad() {
    this.socialIcon = getSvg('share-' + this.type);
  }

  componentDidLoad() {
    if (this.type === 'content') {
      this.shareButtonNode =
        this.hostElement.shadowRoot.querySelector('.share-button');
      this.addShareEvent();
    }
  }

  render() {
    return (
      <Host>
        {this.type === 'content'
          ? this.renderShareButton()
          : this.renderSocialShareAnchor()}
      </Host>
    );
  }
}
